import React from 'react'
import Hero from '../../components/Hero'
import Founder from '../../components/HomePageFounderSection'
import TheBrand from '../../components/HomePageTheBrandSection'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Container, Grid, Divider } from '@mui/material'

const Home = () => {
  return (
    <Container sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }} maxWidth={false} disableGutters>
      <Header/>
      <Container component='main' maxWidth={false} sx={{ flex: 1, pt: '80px' }} disableGutters>
        <Hero/>
        <Grid size={12}>
          <Divider sx={{ mx: 4, my: 2, opacity: 1 }}/>
        </Grid>
        <Founder/>
        <Grid size={12}>
          <Divider sx={{ mx: 4, my: 4, opacity: 1 }}/>
        </Grid>
        <TheBrand/>
      </Container>
      <Footer/>
    </Container>
  )
}

export default Home